import { ConfigKey } from './types.ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getConfig(key: ConfigKey): any {
  const viteKey = `VITE_${key}`;
  return import.meta.env[viteKey];
}
